import store from 'services/redux/store'
import FetchManagementBuilding from 'utils/fetch/management/FetchManagementBuilding'
import HelperDate, { dateFormat } from 'utils/helper-date'
import { selectManagementSelectedStartDate } from 'services/redux/management/reducers'

export const fetchManagementBuildingTimeslots = ( kind, subKind, { callbackStart, callbackSuccess, callbackError }) => {
	const _selectedStartDate = selectManagementSelectedStartDate( store.getState() )
	
	const managementSelectedSingleDate = _selectedStartDate ? HelperDate.date( _selectedStartDate ) :  HelperDate.date();
	const formattedDate = managementSelectedSingleDate.format( dateFormat.DATE );
	
	FetchManagementBuilding.fetchAllTimeslots({
		kind: kind,
		subKind: subKind,
		date: formattedDate,
		callbackStart,
		callbackSuccess,
		callbackError,
	})
}
